import { LicenseErrorInfo } from 'constants/errors/license_error_codes';
import { DeepTeams, Team } from 'contexts/teams/types';
import { UserInvites } from 'contexts/users/types';
import { AccountInvite } from 'pages/Users/components/InviteUsers';
import { Invite } from 'pages/Users/components/InviteUsers/AddByEmails/invitesReducer';

export interface ITeamInviteWizard {
  team: Team | DeepTeams;
  account: AccountInvite;
  /** False right after the team is created. */
  isInvite: boolean;
  /** Gets `true` when anything was saved. */
  onClose: (saved?: boolean) => void;
}

export enum WizardStep {
  SELECT = 'select',
  ERRORS = 'errors',
  ACCESS = 'access',
  MESSAGE = 'message',
  OUTCOME = 'outcome',
}

export type UsersStatus = 'loading' | 'ready' | 'failed';

export interface ISelectUsersStep {
  users: UserInvites[];
  usersStatus: UsersStatus;
  /** The existing users picked so far, as access-step rows. */
  selectedUsers: Invite[];
  onToggleUser: (user: UserInvites) => void;
  onRemoveUser: (id: string) => void;
  emails: string[];
  setEmails: (emails: string[]) => void;
  /** The list only has users from teams the viewer manages, not the whole account. */
  managedTeamsOnly?: boolean;
}

export interface IUserPicker {
  users: UserInvites[];
  status: UsersStatus;
  selectedIds: string[];
  onToggleUser: (user: UserInvites) => void;
  /** The list only has users from teams the viewer manages, not the whole account. */
  managedTeamsOnly?: boolean;
}

export type ChangeResult = 'applied' | 'failed' | 'skipped';

// One change to an existing user: joining the team, their training or Skill Dive license, or
// being made the team's manager after those, which is listed only when it doesn't go through.
export interface ExistingUserChange {
  kind: 'team' | 'training' | 'skill_dive' | 'manager';
  /** True when given, false when taken away. Joining or managing the team is always true. */
  assign: boolean;
  result: ChangeResult;
  licenseError?: LicenseErrorInfo;
}

export interface ExistingUserResult {
  invite: Invite;
  changes: ExistingUserChange[];
}

export interface EmailInvitesResult {
  count: number;
  sent: boolean;
  licenseError?: LicenseErrorInfo;
}

export interface TeamInviteOutcome {
  existingUsers: ExistingUserResult[];
  /** Null when there were no new emails to invite. */
  emailInvites: EmailInvitesResult | null;
}

export interface IInviteOutcome {
  outcome: TeamInviteOutcome;
  teamName: string;
}

export interface EmailError {
  email: string;
  error: string;
}
